import { Meeting, Recording } from '../types/meeting';

export const sampleMeetings: Meeting[] = [
  {
    id: '1',
    topic: 'Due Diligence Review',
    description: 'Review of financial and operational documents with the target company',
    startTime: new Date(Date.now() + 3600000).toISOString(), // 1 hour from now
    duration: 60,
    participants: 8
  },
  {
    id: '2',
    topic: 'Integration Planning',
    description: 'Discussion of post-merger integration strategy and timeline',
    startTime: new Date(Date.now() + 7200000).toISOString(), // 2 hours from now
    duration: 90,
    participants: 12
  },
  {
    id: '3',
    topic: 'Valuation Model Review',
    description: 'Review of updated financial models and synergy estimates',
    startTime: new Date(Date.now() + 86400000).toISOString(), // Tomorrow
    duration: 45,
    participants: 6
  },
  {
    id: '4',
    topic: 'Legal Team Sync',
    description: 'Review of legal documentation and regulatory requirements',
    startTime: new Date(Date.now() + 172800000).toISOString(), // Day after tomorrow
    duration: 60,
    participants: 5
  }
];

export const sampleRecordings: Recording[] = [
  {
    id: 'r1',
    topic: 'Initial Deal Discussion',
    recordingDate: new Date(Date.now() - 86400000).toISOString(), // Yesterday
    duration: 55,
    fileSize: 128000000
  },
  {
    id: 'r2',
    topic: 'Financial Due Diligence',
    recordingDate: new Date(Date.now() - 172800000).toISOString(), // 2 days ago
    duration: 90,
    fileSize: 256000000
  },
  {
    id: 'r3',
    topic: 'Board Presentation',
    recordingDate: new Date(Date.now() - 259200000).toISOString(), // 3 days ago
    duration: 45,
    fileSize: 98000000
  }
];